import { AlertCircle } from "lucide-react";
import naverLogo from "@/assets/iconUpdate/blogSvg.svg"
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

const BASE_URL = import.meta.env.VITE_API_URL;
interface phoneProps {
  phone_number: string,
  country_code : string
}

const findId = async(_payload: phoneProps) => {
  try {
    const res = await fetch(`${BASE_URL}/mobile/find-my-id?phone_number=${_payload.phone_number}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
    return await res.json()
  } catch (error) {
    console.error("Error:", error);
  }
}

const HandleEmail = ({phoneUser}:{phoneUser : phoneProps}) => {

  const {data} = useQuery({
    queryKey: ["find-my-id"],
    queryFn: ()=> findId(phoneUser),
    staleTime: 1000 * 60 * 5
  })


  return (
    <div
      className="flex flex-col items-center space-y-5 w-full mx-auto"
    >
      <div className="items-center justify-center mt-10 bg-gray-100 rounded-full p-2">
        <AlertCircle className="w-16 h-16 p-2 grayscale opacity-20" />
      </div>
      <div className="mt-10">
        <h2 className="font-bold text-[16px] text-center">
        이메일
        </h2>
      </div>
      <div className="relative w-full">
        <div
          className={`flex items-center border overflow-hidden px-2 rounded-md`}
        >
          <input
            type=""
            placeholder="user@gmail.com"
            value={data.data}
            className="flex-1 text-sm outline-none bg-white py-2 pr-4"
          />
        <img src={naverLogo} alt="" />
        </div>
        <div className="w-full text-center mt-20">
          <Link
            to={"/login"}
            type="button"
            className="text-white border-gray-500 shadow-md rounded-sm  bg-[#384D92] border p-2 mt-2 text-xs mt-1 text-center item-center w-full"
          >
            로그인 페이지로
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HandleEmail;
